import axios from 'axios';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';

import { getApiUrl } from '../helpers/api-url';
import { authenticationService } from '../services/authenticationService.service';
import moment from 'moment';

function createTimetablesWebApiHttpClient() {
    const ax = axios.create({
        baseURL: getApiUrl(),
    });

    ax.interceptors.request.use((request) => {
        const controller = new AbortController();
        let currentUser = authenticationService.currentUserValue;
        if (!currentUser) {
            controller.abort();
            toast.error('Attempt authentication in 2 seconds as there is no current user');
            new Promise((res) => setTimeout(res, 2000)).then(() => {
                authenticationService.authenticate();
            });
            return {
                ...request,
                signal: controller.signal,
            };
        } else if (moment.utc(currentUser.tokenExpiration).isBefore(moment.utc())) {
            controller.abort();
            toast.error('Re-authenticating the user in 2 seconds as token has expired');
            new Promise((res) => setTimeout(res, 2000)).then(() => {
                authenticationService.logout();
                authenticationService.authenticate();
            });
            return {
                ...request,
                signal: controller.signal,
            };
        } else {
            request.headers.setAuthorization(`Bearer ${authenticationService.currentUserValue?.token}`);
            return request;
        }
    });

    ax.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

            if (!expectedError) {
                toast.error('Unexpected error occurred. This error has been logged for review by support staff. Email ttportal@bcit.ca if the error continues to persist.', {
                    autoClose: false,
                });
            } else {
                if (error.response.data?.error) toast.error(error.response.data?.error, { autoClose: false });
                else if (error.response.data?.message) toast.error(error.response.data.message, { autoClose: false });
                else toast.error(error.response.data, { autoClose: false });
                Sentry.captureException(error);
            }

            return Promise.reject(error);
        },
    );

    return ax;
}

export default createTimetablesWebApiHttpClient;
